import Layout from '@/layout/base/layoutSegfy'

// "Segurança" é o item de menu que vem da auth (chave SEGFY_SEGURANCA, link
// /seguranca). O destino é a página de passagem do SSO no app novo, que entrega o
// corretor autenticado no produto — ver components/seguranca/abrir.vue.
export default [{
  path: '/seguranca',
  component: Layout,
  children: [{
    path: '',
    name: 'seguranca',
    component: () => import('@/components/seguranca/abrir'),
    meta: {
      auth: true
    }
  }]
}]
